export default __webpack_public_path__ + "static/media/trr-drink-specialty-cerealmilk.2b2f5f3f.png";